<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <h4 class="d-flex align-items-center">
        <font-awesome-icon class="mr-1" icon="fa-solid fa-bell" />
        <span class="ml-1"
          >{{ newMessageData.id > 0 ? "編輯" : "新增" }}訊息</span
        >
      </h4>
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="mt-3" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="mt-2 mt-sm-3 position-relative">
            <b-row>
              <!-- Message order number -->
              <!-- <b-col cols="12" md="12">

                  <b-form-group
                    label="單號："
                    label-for="order_number"
                    label-cols-md="3"
                    class=""
                  >
                    <b-form-input
                      id="order_number"
                      v-model="newMessageData.order_number"
                      placeholder="輸入單號"
                    />
                  </b-form-group>
              </b-col> -->

              <b-col cols="12" md="12">
                <b-form-group
                  :label="getDocTypeLabel(newMessageData.message_document_type_id)"
                  label-for="id"
                  label-cols-md="2"
                  :class="{ required: newMessageData.message_document_type_id !== 5 }"
                >
                  <b-row>
                    <b-col cols="2" class="d-flex align-items-center">
                      <!-- <span class="text-nowrap">過濾：</span> -->
                      <v-select
                        id="newMessageData.message_document_type_id"
                        v-model="newMessageData.message_document_type_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="documentTypeOptions"
                        :clearable="false"
                        class="w-100"
                        label="name"
                        :reduce="(option) => option.id"
                        placeholder="過濾單據類型"
                        @input="onFilteredDocumentTypeChange"
                      >
                      </v-select>

                    </b-col>
                    <b-col cols="10" class="d-flex align-items-center" v-if="!isSystemMessage()">

                      <v-select
                        v-if="newMessageData.message_document_type_id == 1"
                        id="project_id"
                        v-model="newMessageData.project_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="projectOptions"
                        class="w-100"
                        :clearable="false"
                        label="project_name"
                        :reduce="(option) => option.id"
                        placeholder="選擇項目"
                        :filter="projectSearch"
                        @input="handleProjectChange"
                      >
                        <template #option="{ project_name, project_number }">
                          [{{ project_number }}] {{ project_name }}
                        </template>
                        <template
                          #selected-option="{ project_name, project_number }"
                        >
                          [{{ project_number }}] {{ project_name }}
                        </template>
                      </v-select>
                      <v-select
                        v-if="newMessageData.message_document_type_id == 2"
                        id="quotation_id"
                        v-model="newMessageData.quotation_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="quotationOptions"
                        class="w-100"
                        :clearable="false"
                        label="id"
                        :reduce="(option) => option.id"
                        placeholder="選擇報價單"
                        :filter="quotationSearch"
                      >
                      <!-- @input="handleQuotationChange" -->
                        <template #option="{ quotation_number, name_cn }">
                          {{ quotation_number }} {{ name_cn }}
                        </template>
                        <template
                          #selected-option="{ quotation_number, name_cn }"
                        >
                          {{ quotation_number }} {{ name_cn }}
                        </template>
                      </v-select>
                      <v-select
                        v-else-if="newMessageData.message_document_type_id == 3"
                        id="invoice_id"
                        v-model="newMessageData.invoice_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="invoiceOptions"
                        class="w-100"
                        :clearable="false"
                        label="invoice_number"
                        :reduce="(option) => option.id"
                        placeholder="選擇發票"
                        :filter="invoiceSearch"
                        @input="handleInvoiceChange"
                      >
                        <template #option="{ invoice_number, project_name, quotation_number }">
                          {{ invoice_number }} {{ project_name }} {{quotation_number}}
                        </template>
                        <template
                          #selected-option="{ invoice_number, project_name, quotation_number }"
                        >
                          {{ invoice_number }} {{ project_name }} {{quotation_number}}
                        </template>
                      </v-select>
                      <v-select
                        v-else-if="newMessageData.message_document_type_id == 4"
                        id="receipt_id"
                        v-model="newMessageData.receipt_id"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="receiptOptions"
                        class="w-100"
                        :clearable="false"
                        label="receipt_number"
                        :reduce="(option) => option.id"
                        placeholder="選擇收據"
                        :filter="receiptSearch"
                      >
                        <template #option="{ receipt_number, project_name }">
                          {{ receipt_number }} {{ project_name }}
                        </template>
                        <template
                          #selected-option="{ receipt_number, project_name }"
                        >
                          {{ receipt_number }} {{ project_name }}
                        </template>
                      </v-select>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>

              <!-- message_status_id -->
              <b-col cols="12">
                <b-form-group
                  label="地址："
                  label-for="message_address"
                  label-cols-md="2"
                  class=""
                >
                  <b-form-input
                    id="message_address"
                    v-model="newMessageData.address"
                    placeholder="輸入地址"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group
                  label="群發或個人："
                  label-for="message_type_radio"
                  label-cols-md="2"
                >
                  <b-form-radio-group
                    id="message_type_radio"
                    v-model="newMessageData.is_group"
                    :options="[
                      { text: '群發', value: 1 },
                      { text: '個人', value: 0 },
                    ]"
                    name="message_type_radio"
                    @change="onIsGroupChange"
                  ></b-form-radio-group>
                </b-form-group>
              </b-col>
              <!-- type -->
              <b-col cols="12" v-if="newMessageData.is_group === 1">
                <b-form-group
                  label="接收群組："
                  label-for="message_type"
                  label-cols-md="2"
                  class=""
                >
                  <v-select
                    id="message_type"
                    v-model="newMessageData.user_type_id"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :options="userTypeOptions"
                    :clearable="true"
                    label="type"
                    :reduce="(option) => option.id"
                    placeholder="請選擇群組"
                    @input="onUserTypeChange"
                    :disabled="
                      newMessageData.user_ids &&
                      newMessageData.user_ids.length > 0
                        ? true
                        : false
                    "
                  >
                  </v-select>
                </b-form-group>
              </b-col>

              <b-col cols="12" md="12" v-if="newMessageData.is_group === 0">
                <b-form-group
                  label="接收者："
                  label-for="receive_user"
                  label-cols-md="2"
                >
                  <b-row>
                    <b-col cols="5">
                      <b-row>
                        <b-col cols="6" class="d-flex align-items-center">
                          <span class="text-nowrap">過濾：</span>
                          <v-select
                            id="filtered_type"
                            class="w-100"
                            v-model="filteredUserType"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="userTypeOptions"
                            :clearable="true"
                            label="type"
                            :reduce="(option) => option.id"
                            placeholder="請選擇過濾種類"
                            @input="onFilteredUserTypeChange"
                          >
                          </v-select>
                        </b-col>
                        <b-col cols="6">
                          <v-select
                            id="filtered_user"
                            v-model="filteredUser"
                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                            :options="forFilteredUserOptions"
                            :clearable="true"
                            label="name"
                            :reduce="(option) => option.id"
                            :disabled="filteredUserType ? false : true"
                            placeholder="請選擇過濾接收者"
                            :filter="userSearch"
                            @input="onFilteredUserChange"
                          >
                            <template #option="{ roles, name_cn }">
                              <template v-if="roles && roles[0]">
                                [{{ roles[0].name }}] {{ name_cn }}
                              </template>
                              <template v-else>
                                {{ name_cn }}
                              </template>
                            </template>
                            <template #selected-option="{ roles, name_cn }">
                              <template v-if="roles && roles[0]">
                                [{{ roles[0].name }}] {{ name_cn }}
                              </template>
                              <template v-else>
                                {{ name_cn }}
                              </template>
                            </template>
                          </v-select>
                        </b-col>
                      </b-row>
                    </b-col>
                    <b-col cols="7">
                      <v-select
                        id="receive_user"
                        v-model="newMessageData.user_ids"
                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                        :options="userOptions"
                        :clearable="true"
                        label="name"
                        :reduce="(option) => option.id"
                        multiple
                        placeholder="請選擇接收者"
                        :filter="userSearch"
                        @input="onUserIdsChange"
                      >
                        <template #option="{ roles, name_cn }">
                          <template v-if="roles && roles[0]">
                            [{{ roles[0].name }}] {{ name_cn }}
                          </template>
                          <template v-else>
                            {{ name_cn }}
                          </template>
                        </template>
                        <template #selected-option="{ roles, name_cn }">
                          <template v-if="roles && roles[0]">
                            [{{ roles[0].name }}] {{ name_cn }}
                          </template>
                          <template v-else>
                            {{ name_cn }}
                          </template>
                        </template>
                      </v-select>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>

              <!-- Message content -->
              <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                >
                  <b-form-group
                    label="訊息內容："
                    label-for="message_content"
                    label-cols-md="2"
                    class="required"
                  >
                    <b-form-textarea
                      id="message_content"
                      class="w-100"
                      v-model="newMessageData.content"
                      placeholder="輸入訊息內容"
                      :state="getValidationState(validationContext)"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </div>

          <div class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-sm-2 mobile-w100"
              type="submit"
            >
              <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
              提交
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
              class="mt-1 mt-sm-0 mobile-w100"
            >
              取消
            </b-button>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BButton,
  BOverlay,
  BFormTextarea,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";

export default {
  data() {
    return {
      required,
      filteredUserType: null,
      filteredUser: null,
    };
  },
  directives: {
    Ripple,
  },
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BRow,
    BCol,
    BButton,
    BOverlay,
    flatPickr,
    vSelect,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
  },
  computed: {
    filteredUserOptions() {
      if (this.newMessageData.user_type_id) {
        return this.userOptions.filter(
          (user) => user.user_type_id == this.newMessageData.user_type_id
        );
      } else {
        return this.userOptions;
      }
    },
    forFilteredUserOptions() {
      return this.filteredUserOptions.filter(
        (user) => user.user_type_id == this.filteredUserType
      );
    },
    documentTypeOptions() {
      const mapName = (t) => ({
        Project: '項目',
        Quotation: '報價單',
        Invoice: '發票',
        Receipt: '收據',
        System: '系統訊息',
      }[t] || t);
      return (this.messageDocumentTypeOptions || []).map(d => ({ id: d.id, name: mapName(d.document_type) }));
    },
  },
  methods: {
    onFilteredDocumentTypeChange() {
      this.newMessageData.project_id = null;
      this.newMessageData.quotation_id = null;
      this.newMessageData.invoice_id = null;
      this.newMessageData.receipt_id = null;
    },
    onIsGroupChange() {
      this.newMessageData.user_ids = [];
      console.log("onIsGroupChange", this.newMessageData.is_group);
      this.newMessageData.user_type_id = null;
      this.filteredUserType = null;
      this.filteredUser = null;
    },
    onFilteredUserTypeChange() {
      this.filteredUser = null;
    },
    onFilteredUserChange() {
      if (this.filteredUser) {
        this.newMessageData.user_ids.push(this.filteredUser);
      }
    },
    onUserTypeChange() {
      console.log("onUserTypeChange", this.newMessageData.user_type_id);
      this.newMessageData.user_ids = [];
    },
    onUserIdsChange() {
      //console.log('onUserIdsChange', this.newMessageData.user_ids)
      this.newMessageData.user_type_id = null;
    },
    hide() {
      this.$router.replace("/messages/list");
    },
    projectSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.project_name.toLowerCase().includes(search.toLowerCase()) ||
          item.project_number.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    quotationSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.quotation_number.toLowerCase().includes(search.toLowerCase()) ||
          item.name_cn.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    invoiceSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return item.invoice_number.toLowerCase().includes(search.toLowerCase());
      });
      return returnOptions;
    },
    receiptSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return item.receipt_number.toLowerCase().includes(search.toLowerCase());
      });
      return returnOptions;
    },
    userSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.name_cn.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    onSubmit() {
      // 檢查 user_type_id 或 user_ids 是否至少填寫了一個
      if (
        !this.newMessageData.user_type_id &&
        (!this.newMessageData.user_ids ||
          this.newMessageData.user_ids.length === 0)
      ) {
        this.$swal({
          title: "錯誤",
          text: "請選擇接收群組或接收者中的至少一項",
          icon: "warning",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
          timer: 5000,
          timerProgressBar: true,
        });
        return;
      }

      if (this.newMessageData.user_type_id &&
        (this.newMessageData.user_ids &&
          this.newMessageData.user_ids.length > 0)
      ) {
        this.$swal({
          title: "錯誤",
          text: "不能同時選擇接收群組和接收者",
          icon: "warning",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
          timer: 5000,
          timerProgressBar: true,
        });
        return;
      }

      // 添加工具函数
      const safeFind = (array, id, defaultValue = null) => {
        if (!array || !Array.isArray(array)) return defaultValue;
        return array.find(item => item.id === id) || defaultValue;
      };

      // 获取单号
      const getOrderNumber = () => {
        const documentType = this.newMessageData.message_document_type_id;
        let result = null;
        if (this.isSystemMessageId(documentType)) {
          return null;
        }

        switch(documentType) {
          case 2:
            result = safeFind(this.quotationOptions, this.newMessageData.quotation_id);
            return result?.quotation_number;
          case 3:
            result = safeFind(this.invoiceOptions, this.newMessageData.invoice_id);
            return result?.invoice_number;
          case 4:
            result = safeFind(this.receiptOptions, this.newMessageData.receipt_id);
            return result?.receipt_number;

          default:
            result = safeFind(this.projectOptions, this.newMessageData.project_id);
            return result?.project_number;
        }
      };

      const documentType = this.newMessageData.message_document_type_id;
      const orderNumber = getOrderNumber();
      if (!this.isSystemMessageId(documentType) && !orderNumber) {
        this.$swal({
          title: "錯誤",
          text: "找不到對應的單號",
          icon: "warning",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      this.newMessageData.order_number = this.isSystemMessageId(documentType) ? null : orderNumber;

      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("message/editMessage", this.newMessageData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.hide();
              // if (this.newMessageData.id == 0) {
              //   this.newMessageData.id = response.data.id;
              //   this.redirect(response.data.id);
              // }
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
    // 取得後端 System 類型的實際 ID
    getSystemTypeId() {
      const rec = (this.messageDocumentTypeOptions || []).find(d => d.document_type === 'System');
      return rec ? rec.id : null;
    },
    // 檢查是否為 System 類型 ID
    isSystemMessageId(id) {
      const sysId = this.getSystemTypeId();
      return sysId != null && id === sysId;
    },
    // 目前選擇是否為 System 類型
    isSystemMessage() {
      return this.isSystemMessageId(this.newMessageData.message_document_type_id);
    },
    // 依據 ID 顯示標籤
    getDocTypeLabel(id) {
      const rec = (this.messageDocumentTypeOptions || []).find(d => d.id === id);
      const mapName = (t) => ({
        Project: '項目',
        Quotation: '報價單',
        Invoice: '發票',
        Receipt: '收據',
        System: '系統訊息',
      }[t] || '單據');
      return rec ? mapName(rec.document_type) : '單據';
    },
  },
  props: {
    messageData: {
      type: Object,
      required: true,
    },
    userOptions: {
      type: Array,
      required: true,
    },
    userTypeOptions: {
      type: Array,
      required: true,
    },
    projectOptions: {
      type: Array,
      required: true,
    },
    quotationOptions: {
      type: Array,
      required: true,
    },
    messageDocumentTypeOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
    invoiceOptions: {
      type: Array,
      required: true,
    },
    receiptOptions: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, { emit }) {
    const newMessageData = ref({
      id: 0,
      message_document_type_id: null,
      project_id: null,
      invoice_id: null,
      receipt_id: null,
      quotation_id: null,
      user_ids: [],
      user_type_id: null,
    });

    watch(
      () => props.messageData,
      (newVal) => {
        newMessageData.value = { ...newVal };
      }
    );
    const resetWorkData = () => {
      newMessageData.value = JSON.parse(
        JSON.stringify({
          id: 0,
          user_ids: [],
          user_type_id: null,
        })
      );
    };
    const handleProjectChange = (project_id) => {
      const project = safeFind(props.projectOptions, project_id);
      if (!project) return;

      newMessageData.value.address = project.address;
      newMessageData.value.is_group = 0;
      newMessageData.value.user_ids = [
        ...(project.users?.map(user => user.id) || []),
        project.customer_id,
        project.manager_id
      ].filter(Boolean); // 移除可能的 null/undefined 值
    };

    // const handleQuotationChange = () => {
    //   const quotation = props.quotationOptions.filter(
    //     (ele) => ele.id == newMessageData.value.quotation_id
    //   )[0];
    //   handleProjectChange(quotation.project_id);
    // };

    const handleInvoiceChange = () => {
      const invoice = safeFind(props.invoiceOptions, newMessageData.value.invoice_id);
      if (!invoice) return;

      handleProjectChange(invoice.project_id);
    };
    // const handleReceiptChange = () => {
    //   const receipt = props.receiptOptions.filter(
    //     (ele) => ele.id == newMessageData.value.receipt_id
    //   )[0];
    //   handleProjectChange(receipt.project_id);
    // };


    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetWorkData);

    const documentTypeOptions = ref([
      { id: 1, name: "項目" },
      { id: 2, name: "報價單" },
      { id: 3, name: "發票" },
      { id: 4, name: "收據" },
      { id: 5, name: "系統訊息" },
    ]);

    return {
      refFormObserver,
      getValidationState,
      resetForm,
      newMessageData,
      handleProjectChange,
      // handleQuotationChange,
      handleInvoiceChange,
      documentTypeOptions,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
#receive_user {
  .vs__selected-options input {
    padding: 0 15px;
  }
}
</style>

<style lang="scss" scoped>
</style>
